import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';
import { StyleType } from '~types/common';

type CheckboxType = {
  inputCss?: StyleType;
  isBorder: boolean;
  checkboxSize: 'lg' | 'md';
};
const lgSize = css`
  width: 24px;
  height: 24px;

  background-size: 20px 20px;
`;

const mdSize = css`
  width: 20px;
  height: 20px;

  background-size: 16px 16px;
`;
export const S = {
  CheckboxWrapper: styled.div`
    display: flex;
    position: relative;

    /* svg {
      position: absolute;

      cursor: pointer;
    } */
  `,
  StyledCheckbox: styled.input<CheckboxType>`
    appearance: none;
    background-image: url('/images/check_off.svg');
    background-color: ${({ theme }) => theme.colors.white100};
    background-position: 50%;
    background-repeat: no-repeat;
    border-radius: 3px;
    ${(props) => (props.checkboxSize === 'lg' ? lgSize : mdSize)};

    ${(props) =>
      props.isBorder &&
      css`
        border: 1px solid ${({ theme }) => theme.colors.gray400};
      `}
    :checked {
      ${(props) => (props.checkboxSize === 'lg' ? lgSize : mdSize)};
      background-color: ${({ theme }) => theme.colors.white100};
      ${(props) =>
        props.isBorder
          ? css`
              border: 1px solid ${({ theme }) => theme.colors.magenta700};
              background-color: ${({ theme }) => theme.colors.magenta700};
              background-image: url('/images/check_white_on.svg');
            `
          : css`
              background-image: url('/images/check_magenta_on.svg');
            `}
    }

    :disabled {
      background-image: url('/images/checkbox_disabled.png');
      background-size: 14px 11px;
      background-position: 50%;
      background-repeat: no-repeat;
      background-color: ${({ theme }) => theme.colors.white100};

      ${({ isBorder }) =>
        isBorder &&
        css`
          border: 1px solid ${({ theme }) => theme.colors.gray400};
        `}
    }

    ${({ inputCss }) => inputCss};
  `,
  CheckboxLabel: styled.label<{ labelCss?: StyleType; checkboxSize: CheckboxType['checkboxSize'] }>`
    margin-left: 8px;
    height: 100%;
    padding-top: ${({ checkboxSize }) => (checkboxSize === 'lg' ? '4px' : '2px')};
    ${({ checkboxSize }) => getFontStyle(checkboxSize === 'lg' ? 'midium150_B1' : 'midium150_B3')};

    ${(props) => props.labelCss};
    line-height: 1;
  `,
};
